import BookingFlowGlobalStyles from './booking-flow-global';
import OktaSigninSignupStyles from './okta-signin-signup';
import QuoteSummaryStyles from './quote-summary';
import ContainerSelectionStyles from './container-selection';
import NBFContainerSelectionStyles from './nbf-container-selection';
import PackingAndLoadingAssistanceStyles from './packing-and-loading-assistance';
import ContainerPlacementStyles from './container-placement';
import ProtectionsStyles from './protections';
import PaymentStyles from './payment';
import TermsStyles from './terms-agreement';
import VideoStyles from './video';
import ConfirmationStyles from './order-confirmation';
import PromoStyles from './promo-banner';

module.exports = {
    //Using these functions allows you to hide an element without having to worry if it's a Block/Inline/Flex/etc to begin with.
    //If you need to manipulate the CSS Visibility property, use the Bootstrap 'visible' and 'invisible' classes.
    //'d-none' changes the CSS Display property.
    ToggleElementWithLabel: function (toggleTarget, currentObj, changeLabel, labelForHide, labelForShow) {
        PODSLib.ToggleElement(toggleTarget);
        if (changeLabel) {
            if (currentObj.innerHTML.trim().startsWith("+") || currentObj.innerHTML.trim().startsWith("Show")) {
                currentObj.innerHTML = '- ' + labelForHide;
            }
            else {
                currentObj.innerHTML = '+ ' + labelForShow;
            }
        }
    },
    ToggleElementWithLabelNBF: function (toggleTarget, currentObj, changeLabel, labelForHide, labelForShow) {
        PODSLib.ToggleElement(toggleTarget);
            if (currentObj.classList.contains("open")) {
                currentObj.innerHTML = labelForHide;
                currentObj.insertAdjacentHTML( 'afterbegin','<span class="caret caret-up"></span>');
                currentObj.classList.remove('open');
            }
            else {
                currentObj.innerHTML = labelForShow;
                currentObj.insertAdjacentHTML( 'afterbegin','<span class="caret"></span>');
                currentObj.classList.add('open');
            }

    },
    ToggleElement: function (targetElement) {
        $(targetElement).toggleClass("d-none");
    },
    ShowElement: function (targetElement) {
        $(targetElement).removeClass("d-none");
    },
    HideElement: function (targetElement) {
        $(targetElement).addClass("d-none");
    },
    ScrollToElement: function (targetElement) {
        //Scroll to the provided element, then back up to the outerHeight (calculating Padding/Margin/Borders/etc) of the header
        //and also add 16 pixels of padding to give some breathing room.
        $('body,html').animate({
            scrollTop: $(targetElement).offset().top - $('header.header-static').outerHeight() - 16
        });
    },
    PostToBookingFlowAPI: function (endpointName, dataObj) {
        $.ajax({
            type: 'POST',
            url: '/api/PODS/BookingFlowComponents/' + endpointName,
            dataType: "json",
            data: dataObj,
            success: function(response){
                if(response != ""){
                    location.href = response;
                }
            }
        })
    },
    PostToBookingFlowAPIFetch: async (endpointName, dataObj) => {
        return fetch(`/api/PODS/BookingFlowComponents/${endpointName}`, {
            method: 'POST',
            body: JSON.stringify(dataObj), // json.serialize
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    GetItemPriceFromOptionText: function (selector) {
        var selectedOptionText = $(selector).text();
        var selectedOptionStringArray = selectedOptionText.split("-");
        var selectedOptionPriceString = selectedOptionStringArray[selectedOptionStringArray.length - 1];
        var selectedOptionPrice = selectedOptionPriceString.replace("$", "").replace(" ", "");
        return selectedOptionPrice;
    },
    SetCheckOutDataLayer: function(datalayer){
        localStorage.setItem("dataLayer", JSON.stringify(datalayer));
    },
    GetCheckOutDataLayer: function(){
        var dataLayer = localStorage.getItem("dataLayer");
        return JSON.parse(dataLayer);
    }
};
//RS TODO: Set up global states here

var chkFlag = false;
var numberRegEx = /^[0-9]+$/;
var pinElem, pinVal;
$("#txtCreatePinEntry,#txtLoginPinEntry").on("keyup", function(){
    pinElem = $(this);
    pinVal = $(this).val();
    chkFlag = numberRegEx.test(pinVal);
    //console.log($(this).val(), numberRegEx.test(pinVal));

    let validNumberDisplay = pinElem.siblings(".sms-option").find(".password-conditions .valid-number");
    if(chkFlag == true && pinVal.length == 4 && validNumberDisplay.length){
        validNumberDisplay.removeClass("noPass").addClass("pass");
    } else if (validNumberDisplay.length) {
        validNumberDisplay.removeClass("pass").addClass("noPass");
    }
})
if ($('.okta-signup-signin select').length) {
    $('.okta-signup-signin select').chosen({
        width: '100%',
        disable_search: true
    });
    $.validator.setDefaults({ ignore: ":hidden:not('.okta-signup-signin select')" });
    $(".okta-signup-signin select").each(function() {
        if ($(this).attr('required') !== undefined) {
            $(this).on("change", function() {
                $(this).valid();
            });
        }
    })
}
